import { APIClient } from "./api_helper";
import * as url from "./url_helper";

const api = new APIClient();

export const getLibrarySongs = (libraryId, page = 1, itemsPerPage = 10, search = '') => {
  const params = new URLSearchParams({
    page: page.toString(),
    itemsPerPage: itemsPerPage.toString()
  });
  if (search) {
    params.append('search', search);
  }
  return api.get(`${url.GET_LIBRARY_SONGS(libraryId)}?${params.toString()}`);
};

export const addSongToLibrary = (data) => api.create(url.POST_LIBRARY_SONG, data);

export const addBulkSongsToLibrary = (data) => api.create(url.POST_BULK_LIBRARY_SONGS, data);

export const deleteSongFromLibrary = (id) => api.delete(url.DELETE_LIBRARY_SONG(id));
